var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-cell"},[_c('div',{staticClass:"title-cell-item"},[_c('div',{class:{ double: _vm.index % 2 == 0, single: _vm.index % 2 != 0, label: true }},_vm._l((_vm.item.label),function(j,index){return _c('div',{key:index},[_vm._v("\n        "+_vm._s(j)+"\n      ")])}),0),_vm._v(" "),_c('div',{class:{
        'cell-double': _vm.index % 2 == 0,
        'cell-single': _vm.index % 2 != 0,
      }},_vm._l((_vm.item.value),function(i,key){return _c('content-cell',{key:key,attrs:{"content":i}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/tariff/title-type/title-cell.vue?vue&type=template&id=78ce91b4&scoped=true
// module id = null
// module chunks = 